import React, {FC} from 'react';
import Accordion from 'react-bootstrap/Accordion';
import classNames from 'classnames';
import DynamicAsset from 'components/DynamicAsset';
import {BG} from 'constants/index';

import * as styles from './styles.module.scss';

type PanelProps = {
	bg: BG
	defaultActiveKey?: string
    imageSrc: string;
	showImageOnMobile?: string
	title: string
	children: React.ReactNode
}

const PanelWithAccordions: FC<PanelProps> = ({
	bg,
	defaultActiveKey,
	imageSrc,
	showImageOnMobile,
	title,
	children,
}) => {
	return (
		<div className={classNames({
			[styles.wrapper]: true,
			[styles.light]: bg === BG.light,
			[styles.dark]: bg === BG.dark,
		})}>
			<div className={styles.panel}>
				<DynamicAsset
					imageSrc={imageSrc}
					className={classNames({
						[styles.image]: true,
						[styles.hideMobile]: !showImageOnMobile,
					})}
				/>
				<div className={styles.content}>
					<h4 className={styles.title}>
						{title}
					</h4>
					<Accordion
						className={styles.accordion}
						defaultActiveKey={defaultActiveKey}
					>
						{children}
					</Accordion>
				</div>
			</div>
		</div>
	);
};

export default PanelWithAccordions;
